function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.735 11.362l-4.768 4.408-4.702-4.408a1.392 1.392 0 00-1.872 0 1.207 1.207 0 00-.393.884c0 .332.141.65.393.884l5.63 5.28c.25.235.59.368.944.368s.693-.133.943-.369l5.697-5.279c.252-.234.393-.552.393-.884 0-.332-.141-.65-.393-.884a1.392 1.392 0 00-1.872 0z",
  id: "path-chevron-down"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#path-chevron-down",
  transform: "translate(-8 -11)",
  fillRule: "evenodd"
})));